import styled from 'styled-components'

export const PostDate = styled.p`
  color: ${ props => props.theme.toggleBorder };
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 0px;
  margin-top: 0px;
`